import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.textiframe = {
    update: function(element, va, bindings, model, context) {
        var doc_text = ko.unwrap(va());
        var iframe_doc = element.contentWindow.document;
        iframe_doc.open();
        iframe_doc.write(doc_text);
        iframe_doc.close();
    }
};
